import { render, staticRenderFns } from "./dashboard.compoment.vue?vue&type=template&id=79a580bd&scoped=true"
import script from "./dashboard.compoment.vue?vue&type=script&lang=ts"
export * from "./dashboard.compoment.vue?vue&type=script&lang=ts"
import style0 from "../dashboard.style.scss?vue&type=style&index=0&id=79a580bd&prod&lang=scss&scoped=true&external"
import style1 from "./dashboard.compoment.vue?vue&type=style&index=1&id=79a580bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a580bd",
  null
  
)

export default component.exports